const isSegmentedId = function (recordingId) {
    return (
        /^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}-.+/i.exec(
            recordingId
        ) !== null
    );
};

const getOriginalRecordingId = function (recordingId) {
    if (!isSegmentedId(recordingId)) {
        return recordingId;
    }

    return recordingId.substring(0, 36);
};

export default {
    isSegmentedId: isSegmentedId,
    getOriginalRecordingId: getOriginalRecordingId,
};
